import React, { useContext, useMemo, useState, useEffect } from 'react';
import "./news-detail.scss";
import { Link, useParams } from "react-router-dom";
import { Buffer } from 'buffer';
import { AppContext } from '../../services/translationContext';
import { Loader } from '../../components/loader/loader';
import axios from 'axios';
import XMLParser from 'react-xml-parser';

const api = process.env.REACT_APP_URL_API;
const pathUrl = process.env.REACT_APP_BASE_URL;
const textstring = `
<p class="syd-art-lead">
    La Macedonia del Nord sta entrando in una nuova fase della <b>digitalizzazione fiscale</b>. Con l'introduzione di e-Faktura, il Paese avvia un percorso verso la <b>fatturazione elettronica obbligatoria per le transazioni non in contanti</b>, con l'obiettivo di rendere più trasparente, efficiente e controllabile l'intero processo di fatturazione.
  </p>

  <p>Per le aziende, questo non è solo un aggiornamento normativo, ma di un cambiamento concreto che impatta direttamente sistemi gestionali, processi amministrativi e flussi contabili. </p>

  <h2>Cos'è e-Faktura</h2>
  <p>
    <b>e-Faktura</b> è il nuovo sistema centralizzato di fatturazione elettronica gestito dall'<b>Ufficio delle Entrate Pubbliche (PRO)</b> della Macedonia del Nord. Le fatture non vengono più trattate come semplici documenti PDF inviati via e-mail, ma come <strong>documenti strutturati trasmessi e convalidati</strong> attraverso un sistema centrale.
  </p>
  <p>
    Ogni fattura per transazioni non in contanti deve essere emessa e convalidata elettronicamente attraverso la piattaforma centrale DAP. Solo dopo la validazione in tempo reale, il sistema assegna un <strong>codice univoco (eID)</strong> che certifica l'autenticità del documento.
  </p>

  <div class="syd-art-highlight-box">
    <p><strong>Continuous Transaction Control (CTC)</strong></p>
    <p>Questo modello si inserisce nella logica dei sistemi CTC, sempre più diffusi a livello internazionale, che consentono alle autorità fiscali di monitorare le transazioni in modo rapido e strutturato.</p>
  </div>

  <h2>Come funziona il processo</h2>
  <p>Il processo diventa più controllato e standardizzato:</p>

  <div class="syd-art-steps">
    <div class="syd-art-step">
      <div class="syd-art-step-num">01</div>
      <div class="syd-art-step-content">
        <h4>Emissione</h4>
        <p>L'azienda genera la fattura dal proprio gestionale o dall'applicazione ufficiale del PRO</p>
      </div>
    </div>
    <div class="syd-art-step">
      <div class="syd-art-step-num">02</div>
      <div class="syd-art-step-content">
        <h4>Trasmissione</h4>
        <p>La fattura viene inviata automaticamente alla piattaforma e-Faktura</p>
      </div>
    </div>
    <div class="syd-art-step">
      <div class="syd-art-step-num">03</div>
      <div class="syd-art-step-content">
        <h4>Validazione</h4>
        <p>Il sistema verifica e convalida il documento in tempo reale</p>
      </div>
    </div>
    <div class="syd-art-step">
      <div class="syd-art-step-num">04</div>
      <div class="syd-art-step-content">
        <h4>Conferma</h4>
        <p>Viene assegnato un identificatore univoco (eID) che certifica l'autenticità del documento</p>
      </div>
    </div>
    <div class="syd-art-step">
      <div class="syd-art-step-num">05</div>
      <div class="syd-art-step-content">
        <h4>Consegna</h4>
        <p>La fattura viene recapitata elettronicamente al destinatario, senza necessità di e-mail o documenti fisici</p>
      </div>
    </div>
  </div>

  <p>In questo scenario, il sistema gestionale diventa un elemento chiave per la conformità normativa. </p>

  <h2>Le tappe della riforma</h2>
  <p>Il percorso di introduzione segue una logica graduale, con una fase di test già avviata.</p>

  <div class="syd-art-timeline">
    <div class="syd-art-timeline-card">
      <div class="date-badge">Gennaio 2026</div>
      <h4>Fase pilota</h4>
      <p>Le aziende registrate al sistema e-UJP possono iniziare a testare l'integrazione API e l'invio di fatture di prova.</p>
    </div>
    <div class="syd-art-timeline-card featured">
      <div class="date-badge">Q3 2026 — Ottobre</div>
      <h4>Entrata in vigore</h4>
      <p>Obbligo su larga scala per tutti i contribuenti che emettono fatture per transazioni non in contanti.</p>
    </div>
  </div>

  <h3>Perché questo cambiamento</h3>

  <div class="syd-art-highlight-box syd-art-stat-inline">
    <span class="num">~30%</span>
    <span class="label">del PIL macedone è rappresentato dall'economia informale (Ministero delle Finanze)</span>
  </div>

  <p>L'introduzione di e-Faktura risponde a un'esigenza concreta del sistema fiscale macedone. Gli obiettivi sono chiari: ridurre l'evasione fiscale, modernizzare l'amministrazione fiscale, rafforzare l'applicazione dell'IVA e migliorare il monitoraggio dell'attività economica in tempo reale.</p>

  <h2>Un sistema a doppio binario</h2>
  <p>Uno degli aspetti più rilevanti è la presenza di due flussi distinti, con regole e controlli differenti:</p>

  <div class="syd-art-binario">
    <div class="syd-art-binario-col">
      <div class="syd-art-binario-label">Sistema e-Faktura</div>
      <h4>Transazioni non in contanti</h4>
      <p>Tutte le operazioni B2B e B2G rientreranno nel nuovo sistema di fatturazione elettronica centralizzato.</p>
    </div>
    <div class="syd-art-binario-col">
      <div class="syd-art-binario-label">Regime fiscalizzazione</div>
      <h4>Transazioni in contanti</h4>
      <p>Continuano a seguire le regole di fiscalizzazione tradizionale già in vigore.</p>
    </div>
  </div>

  <p>Questo comporta la necessità di gestire processi paralleli, con regole e controlli differenti. Per le aziende che gestiscono entrambe le tipologie, è fondamentale implementare controlli che distinguano correttamente i due flussi. </p>

  <h2>Impatto operativo per le aziende</h2>
  <p>La nuova normativa non riguarda solo il formato della fattura, ma il modo in cui la fattura viene gestita all’interno dei processi aziendali. </p>
  <p>Per adeguarsi, le aziende dovranno:</p>
  <ul>
    <li>Integrare i propri sistemi con le <b>API e-Faktura</b> </li>
    <li>Gestire <b>formati strutturati</b> (non più solo PDF) </li>
    <li>Tracciare lo stato delle fatture </li>
    <li>Gestire eventuali errori e casi eccezionali </li>
    <li>Aggiornare i processi interni di contabilità e controllo </li>
  </ul>

  <h3>I benefici per le imprese</h3>
  <p>Nonostante l'impatto iniziale, il nuovo sistema offre vantaggi concreti:</p>
  <ul>
    <li><b>Eliminazione della carta</b>: Addio a stampe, archiviazione fisica e processi manuali </li>
    <li><b>Riduzione dei costi</b>: Meno spese logistiche, di archiviazione e di personale dedicato </li>
    <li><b>Maggiore efficienza</b>: Processi automatizzati e riduzione degli errori </li>
    <li><b>Certezza dei dati</b>: Tracciabilità completa e dati contabili verificati in tempo reale </li>
  </ul>
  <p>Prepararsi in anticipo consente di evitare criticità operative e trasformare un obbligo normativo in un <b>vantaggio organizzativo</b>. </p>

  <h2>Aspetti tecnici: Cosa devono sapere le aziende</h2>
  <h3>Formato delle fatture </h3>
  <p>Il sistema e-Faktura si basa su fatture elettroniche strutturate in <strong>formato XML UBL</strong>. Non è sufficiente generare un PDF: il documento deve contenere dati strutturati che la piattaforma possa validare automaticamente.</p>
  <h3>Modalità di integrazione</h3>
  <p>Le aziende hanno due opzioni principali: </p>
  <ol>
    <li><b>Portale web</b>: Portale web gratuiro per piccole imprese o volumi ridotti, il PRO mette a disposizione un'applicazione web dove inserire manualmente le fatture </li>
    <li><b>Integrazione API</b>: Per medie e grandi imprese, l'integrazione tramite API permette al gestionale aziendale di comunicare direttamente con la piattaforma e-Faktura, automatizzando completamente il processo </li>
  </ol>

  <h3>Cosa serve fare ora </h3>
  <ul class="syd-art-checklist">
    <li>Verificare la compatibilità del proprio software gestionale con il nuovo sistema</li>
    <li>Integrare i sistemi ERP con la piattaforma e-Faktura tramite API</li>
    <li>Formare i team interni sui nuovi requisiti tecnici e sui formati strutturati</li>
    <li>Definire procedure per gestire validazioni, rifiuti e correzioni</li>
    <li>Implementare controlli per distinguere fatture e-Faktura da documenti fiscalizzati</li>
  </ul>

  <h2>La soluzione Sydea: SY-Faktura</h2>
  <p>In Sydea conosciamo bene le sfide legate all'integrazione tra normativa e sistemi aziendali e seguiamo da vicino l'evoluzione della normativa e-Faktura. Per questo abbiamo sviluppato <strong>SY-Faktura</strong>, una soluzione progettata per integrarsi nei gestionali aziendali e supportare la gestione della fatturazione elettronica.</p>

  <div class="syd-art-features">
 
    <div class="syd-art-feature-card">
      <div class="syd-art-feature-icon">🔗</div>
      <div class="syd-art-feature-body">
        <h4>Integrazione nativa</h4>
        <p>SY-Faktura si connette direttamente con i principali ERP e gestionali, eliminando doppi inserimenti e garantendo la coerenza dei dati lungo tutto il processo.</p>
      </div>
    </div>
 
    <div class="syd-art-feature-card">
      <div class="syd-art-feature-icon">✔</div>
      <div class="syd-art-feature-body">
        <h4>Conformità garantita</h4>
        <p>La soluzione è progettata per rispettare pienamente i requisiti del sistema e-Faktura macedone, gestendo automaticamente formati XML UBL, validazioni e codici univoci eID.</p>
      </div>
    </div>
 
    <div class="syd-art-feature-card">
      <div class="syd-art-feature-icon">⚖</div>
      <div class="syd-art-feature-body">
        <h4>Gestione del doppio binario</h4>
        <p>SY-Faktura distingue automaticamente tra transazioni soggette a e-Faktura e quelle soggette a fiscalizzazione, semplificando la compliance per le aziende miste.</p>
      </div>
    </div>
 
    <div class="syd-art-feature-card">
      <div class="syd-art-feature-icon">📊</div>
      <div class="syd-art-feature-body">
        <h4>Controllo e visibilità</h4>
        <p>Dashboard complete per monitorare lo stato delle fatture, gestire gli errori di validazione e mantenere la tracciabilità completa in tempo reale.</p>
      </div>
    </div>
 
  </div>
 
  <div class="syd-art-why">
    <div class="syd-art-why-text">
      <div class="hero-syd-art-tag" style="margin-bottom: 16px;">Perché scegliere Sydea</div>
      <p style="color: rgba(255,255,255,0.7); font-size: 16px; margin-bottom: 0;">Con oltre <strong style="color: var(--yellow);">10 anni di esperienza</strong> nell'integrazione di sistemi ERP e nella digitalizzazione dei processi aziendali, Sydea è il partner ideale per accompagnare la tua azienda verso la conformità fiscale in Macedonia del Nord.</p>
      <p style="color: rgba(255,255,255,0.7); font-size: 16px; margin-top: 16px; margin-bottom: 0;">Il nostro team con sede a <strong style="color: var(--yellow);">Skopje</strong> conosce profondamente il contesto normativo locale e può supportarti in ogni fase del progetto: dall'analisi dei requisiti all'implementazione, dalla formazione del personale all'assistenza post go-live.</p>
    </div>
    <div class="syd-art-why-stats">
      <div class="syd-art-why-stat">
        <span class="syd-art-why-num">10+</span>
        <span class="syd-art-why-label">anni di esperienza ERP</span>
      </div>
      <div class="syd-art-why-stat">
        <span class="syd-art-why-num">360°</span>
        <span class="syd-art-why-label">supporto</span>
      </div>
      <div class="syd-art-why-stat">
        <span class="syd-art-why-num">MK</span>
        <span class="syd-art-why-label">team locale a Skopje</span>
      </div>
    </div>
  </div>

  <div class="syd-art-cta-section">
    <span class="product-name">Preparati ora alla fatturazione elettronica</span>
    <h2>L'introduzione è già in corso</h2>
    <p>Muoversi per tempo è fondamentale per arrivare pronti e senza interruzioni operative. Se vuoi capire come adeguare i tuoi sistemi o integrare e-Faktura nei tuoi processi aziendali, il team Sydea è pronto a supportarti.</p>
 
    <div class="syd-art-cta-pills">
      <span class="syd-art-cta-pill">Integrazione nativa ERP</span>
      <span class="syd-art-cta-pill">Conformità XML UBL garantita</span>
      <span class="syd-art-cta-pill">Gestione doppio binario</span>
      <span class="syd-art-cta-pill">Dashboard di controllo</span>
      <span class="syd-art-cta-pill">Team locale a Skopje</span>
    </div>
 
    <a href="mailto:info@sydea.it" class="syd-art-cta-btn">Contattaci per scoprire SY-Faktura →</a>
  </div>
`;

// https://d3t3s6w5yvhc3g.cloudfront.net/media/presentazione-hd.mp4

export const NewsDetail = () => {
  // let { news_id } = useParams();
  // const { services: {TranslationsService} } = useContext(AppContext);
  // const [newsInfo, setNewsInfo] = useState([]);
  // const [showLoader, setShowLoader] = useState(false);

  // useMemo(() => {
  //   setShowLoader(true);
  //   fetch(`${api}/content-public?url_path=${news_id}`)
  //   .then(response => response.json())
  //   .then(data => {
  //     setNewsInfo(data.data[0]);
  //     document.title = `${TranslationsService.labels(`client_stories`)} - ${data.data[0].title} | ${TranslationsService.getMainInfoCompany('name')}`;
  //     setShowLoader(false);
  //   });
  // }, [TranslationsService, news_id]);

  // const getHtmlContent = () => {
  //   try{
  //     let htmlText = Buffer.from(newsInfo.content, "base64");
  //     return htmlText;
  //   }
  //   catch(e){
  //     return '';
  //   }

  // }

  // return (
  //   <div className="section-home light">
  //     {
  //       showLoader &&
  //       <Loader />
  //     }
  //     <section className='hero-story-det syd-hero position-relative p-0' style={{backgroundImage:newsInfo.image?`url(https://d3t3s6w5yvhc3g.cloudfront.net/images/${newsInfo.image})`:''}}>
  //       <div className='overlay-area-info w-100 d-flex flex-column justify-content-center p-5'>
  //         <p className='dark-mode-text m-0 breadcrumb-detail'>
  //           <Link to='/' className='text-deco-none dark-mode-text transition-03s-eio'>Home</Link>
  //           &nbsp;&#9656;&nbsp;
  //           <Link to='/sydea-blog' className='text-deco-none dark-mode-text transition-03s-eio'>Blog</Link>
  //         </p>
  //         <h2 className='syd-title light text-uppercase'>{newsInfo.title}</h2>
  //         <p className='dark-mode-text fs-1 m-0'>{newsInfo.description}</p>
  //       </div>
  //     </section>

  //     <div dangerouslySetInnerHTML={{ __html: getHtmlContent() }} className='w-100 p-3 area-text-cs'></div>
  //   </div>
  // );

  let { news_id, lang } = useParams();
  const { services: {TranslationsService} } = useContext(AppContext);
  const [newsInfo, setNewsInfo] = useState([]);
  const [showLoader, setShowLoader] = useState(false);

  const [posts, setPosts] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  // useEffect(() => {
  //   const fetchPosts = async () => {
  //     try {
  //       const response = await axios.get('https://www.carloliaci.com/feed', {
  //         headers: {'Content-Type': 'application/xml; charset=utf-8'},
  //       });

  //       const xml = new XMLParser().parseFromString(response.data);
  //       const items = xml.getElementsByTagName('item');

  //       setPosts(items);
  //       console.log(items);
  //     } catch (error) {
  //       setError('Errore nel fetch dei dati: ' + error.message);
  //     } finally {
  //       setShowLoader(false);
  //     }
  //   };

  //   fetchPosts();
  // }, []);

  // useMemo(() => {
  //   setTimeout(() => {
  //     const story = TranslationsService.labels(`blog_sect`).filter(x => x.id === news_id)[0];
  //     setNewsInfo(story);
  //     document.title = `Blog - ${story.title} | ${TranslationsService.getMainInfoCompany('name')}`;
  //   }, 10);
  // }, [TranslationsService, news_id]);

useEffect(() => {
    const fetchNews = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await fetch(
          // `${pathUrl}/static/content/blog.json?_cache_buster=${Date.now()}`
          `${pathUrl}/static/content/blog.json?_cache_buster=${new Date().getTime()}`, {cache: 'no-store'}
        );

        if (!response.ok) {
          throw new Error(`Errore HTTP ${response.status}`);
        }

        const data = await response.json();
        const story = data[lang].find((x) => x.id === news_id);

        if (story && story.id !== newsInfo?.id) {
          setNewsInfo(story);
        }
      } catch (err) {
        console.error("Errore nel caricamento del blog:", err);
        setError("Impossibile caricare la notizia.");
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, [news_id]);

  useEffect(() => {
    if (newsInfo?.title) {
      document.title = `Blog - ${newsInfo.title} | ${TranslationsService.getMainInfoCompany("name")}`;
    }
  }, [newsInfo]);

   if (loading) return <p>Caricamento in corso...</p>;

  return (
    <div className="section-home light">
      {
        showLoader &&
        <Loader />
      }
      <section className='hero-story-det syd-hero position-relative p-0' style={{backgroundImage: `url(${newsInfo.image_url})`}}>
        <div className='overlay-area-info w-100 d-flex flex-column justify-content-center'>
          <div className='box-text-section'>
            <div className='area-text-section'>
              <p className='dark-mode-text m-0 breadcrumb-detail'>
                <Link to={`/${lang}`}  className='text-deco-none dark-mode-text transition-03s-eio'>Home</Link>
                &nbsp;&#9656;&nbsp;
                <Link to={`/${lang}/insights`} className='text-deco-none dark-mode-text transition-03s-eio'>{TranslationsService.labels(`menu.insights.label`)}</Link>
                &nbsp;&#9656;&nbsp;
                <Link to={`/${lang}/insights/blog`} className='text-deco-none dark-mode-text transition-03s-eio'>Blog</Link>
              </p>
              <h2 className='title-insights-section fw-bold font-title'>{newsInfo.title}</h2>
              {/* <p className='dark-mode-text fs-4 m-0'>{newsInfo.desc}</p> */}
              <div className='insights-desc-box'>
                <div className='box-line-insights-desc'>
                  <div className='line-insights-desc'></div>
                </div>
                <div className='box-text-insights-desc'>
                  <div className='box-format-text-insights'>
                    <p className='dark-mode-text syd-body-article-p m-0'>{newsInfo.desc}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className='body-text py-5 area-text-cs syd-body-article-p container syd-art-paper'>
        {/* <div dangerouslySetInnerHTML={{ __html: textstring }}></div> */}
        <div dangerouslySetInnerHTML={{ __html: newsInfo.long_text }}></div>
      </div>

      {
        Object.keys(newsInfo).length > 0 && newsInfo.bu_area.key &&
        <div className='d-flex flex-wrap p-3'>

          <Link to={`/${lang}/services/${newsInfo.bu_area.key}`} className='syd-chips transition-03s-eio text-deco-none syd-black breadcrumb-detail' style={{color:'#141414'}}>
            <p className='m-0'>{TranslationsService.labels(`services.${newsInfo.bu_area.key}.title`)}
            {
              newsInfo.bu_area.sub_items &&
              <span> - {TranslationsService.labels('services')[newsInfo.bu_area.key].items[newsInfo.bu_area.sub_items].title}</span>
            }
            </p>
          </Link>
          
          {
            newsInfo.bu_service?.map((service, i) => (
              newsInfo.bu_area.sub_items ?
              (
                <Link key={i} to={`/${lang}/services/${newsInfo.bu_area.key}/${newsInfo.bu_area.sub_items}/${service}`} className='syd-chips transition-03s-eio text-deco-none syd-black breadcrumb-detail' style={{color:'#141414'}}>
                  <p className='m-0 text-end'>{TranslationsService.labels('services')[newsInfo.bu_area.key].items[newsInfo.bu_area.sub_items][service].title}</p>
                </Link>
              )
              :
              (
                <Link key={i} to={`/${lang}/services/${newsInfo.bu_area.key}/${service}`} className='syd-chips transition-03s-eio text-deco-none syd-black breadcrumb-detail' style={{color:'#141414'}}>
                  <p className='m-0'>{TranslationsService.labels(`services.${newsInfo.bu_area.key}.${newsInfo.bu_service}.title`)}</p>
                </Link>
              )
            ))
          }

        </div>
      }

      {/* <div>
        <h1>WordPress Posts</h1>
        <ul>
          {posts.map((post, index) => (
            <li key={index}>
              <h2>{post.title[0]}</h2>
              <div dangerouslySetInnerHTML={{ __html: post.description[0] }} />
            </li>
          ))}
        </ul>
      </div> */}

      {/* <div dangerouslySetInnerHTML={{ __html: getHtmlContent() }} className='w-100 p-3 area-text-cs'></div> */}
    </div>
  );
};
